/**
 * useSupabase — returns the singleton Supabase client.
 *
 * Encapsulating client access in a hook keeps tests clean (the hook can be
 * mocked at module boundary) and gives us a future seam for per-tenant
 * impersonation contexts without rewriting every caller.
 */

import type { SupabaseClient } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabase'

export function useSupabase(): SupabaseClient {
  return supabase
}
